import { Grid } from "@mui/material"
import { PageTitle } from "components"
import { CardConfig } from "components/CardConfig"
import { ContainerPage } from "components/ContainerPage"
import { useAuth } from "hooks/useAuth"
import { enRules } from "interfaces/IUser"
import { FaBalanceScale } from "react-icons/fa"
import { useNavigate } from "react-router"

const Config = () => {
  const {
    user: { rules },
  } = useAuth()
  const HasBatchConfigPermission = rules.includes(enRules.ReplenishmentConfigsBatchesView)
  const navigate = useNavigate()

  const handleNavigateMarkets = () => {
    navigate("/painel-de-admin/configuracoes/mercados")
  }

  const handleNavigateSkus = () => {
    navigate("/painel-de-admin/configuracoes/skus")
  }

  const handleNavigateBatches = () => {
    navigate("/painel-de-admin/configuracoes/lotes")
  }

  const handleNavigateScanner = () => {
    navigate("/painel-de-admin/configuracoes/scanner")
  }

  return (
    <>
      <ContainerPage>
        <PageTitle>Configurações</PageTitle>

        <Grid container style={{ gap: "2rem" }}>
          <Grid item onClick={handleNavigateSkus}>
            <CardConfig Icon={FaBalanceScale} title="SKUs" subTitle="Aqui cê configura cada sku" />
          </Grid>

          <Grid item onClick={handleNavigateMarkets}>
            <CardConfig title="Mercados" subTitle="Aqui cê configura a quantidade de mercados" />
          </Grid>
          <Grid item onClick={handleNavigateScanner}>
            <CardConfig title="Scanner" subTitle="Aqui cê configura o abastecimento com scanner" />
          </Grid>
          {HasBatchConfigPermission && (
            <Grid item onClick={handleNavigateBatches}>
              <CardConfig title="Lotes" subTitle="Aqui cê configura os lotes disponíveis" />
            </Grid>
          )}
        </Grid>
      </ContainerPage>
    </>
  )
}

export default Config
